import Accordion from 'components/common/Accordion/Accordion';
import ContainerHeader from 'components/common/ContainerHeader';
import React from 'react';
import styled from 'styled-components';
import { colors, containerStyles } from 'styles/shared';



const Container = styled.div`
  width: 54.4rem;
  height: 37.5rem;
  padding: 3.9rem 4.8rem 2rem 4.5rem;
  margin-bottom: 5.4rem;
  ${containerStyles};
`;

const Header = styled(ContainerHeader)`
  margin-bottom: 1rem;
`;

function SmallComponent({title}) {
  const TEXT = 'Lorem ipsum dolor sit amet, consectetur';

  let sectionTitle = title
  let items = [
    {id: 1, text: TEXT, color: colors.yellow_main},
    {id: 2, text: TEXT, color: colors.blue_dark, lastItem: true}
  ];


  if (title === "Billing") {
    items = [
      {id: 111, text: "How does billing work?", color: colors.blue_dark},
      {id: 112, text: "How much are extra API requests charged at?", color: colors.green_main},
      {id: 113, text: "When does the billing cycle run?", color: colors.yellow_main},
      {id: 114, text: "Where can I see my monthly spend?", color: colors.purple_main},
      {id: 115, text: "I have a query about my billing, where can I contact you?", color: colors.green_main},
      {id: 116, text: "I have a new card, where can I update it?", color: colors.yellow_main},
    ];
  } else if (title === "Support") {
    items = [
      {id: 121, text: "Where can I see the travel advice for a given country?", color: colors.blue_dark},
      {id: 122, text: "My usage does not seem accurate, how can I query this?", color: colors.green_main},
      {id: 123, text: "The data seems incorrect for a destination, how can you help?", color: colors.yellow_main},
      {id: 124, text: "Where can I use the User Itinerary service?", color: colors.purple_main},
      {id: 125, text: "When are your maintenance hours?", color: colors.green_main},
    ];
  }

  function render() {
    return (
      <Container>
        <Header>{sectionTitle}</Header>

        <Accordion items={items} height={24} />
      </Container>
    );
  }

  return render();
}

export default SmallComponent;
